<script>
import * as Common from '../Common.js'
import {onMount} from 'svelte'
import Chart from 'chart.js'

export let items

let chartElem
let chart

$: items && refreshCount()

onMount(async () => {
    var ctx = chartElem.getContext('2d');
    chart = new Chart(ctx, {
        type: 'doughnut',
        data: {},
        options: {
            legend: {
                display: false
            },
            responsive: false
        }
    });
})

function refreshCount() {
    if(!chart)
        return
        
    let itemTypeCount = {}
    for(let i in items) {
        if(items[i].item_type in itemTypeCount) {
            itemTypeCount[items[i].item_type] += 1
        } else {
            itemTypeCount[items[i].item_type] = 1
        }
    }

    chart.data = {
        labels: ['Praise', 'Criticism', 'Suggestion', 'News', 'Misc.'],
        datasets: [{
            label: 'Item Analysis',
            data:[
                itemTypeCount[Common.ITEMTYPE_PRAISE],
                itemTypeCount[Common.ITEMTYPE_CRITICISM],
                itemTypeCount[Common.ITEMTYPE_SUGGESTION],
                itemTypeCount[Common.ITEMTYPE_NEWS],
                itemTypeCount[Common.ITEMTYPE_MISC]
            ],
            backgroundColor: [
                'rgb(36, 185, 36)',
                'rgb(163, 0, 0)',
                'rgb(6, 118, 205)',
                'rgb(196, 127, 0)',
                '#6f24a9'
            ],
            borderWidth: 2
        }]
    }
    chart.update()
}

</script>

<canvas bind:this={chartElem} width="250" height="250"></canvas>